module.exports = __webpack_public_path__ + "img/cocheLogo.b3080905.svg";